import request from '@/utils/request'

// 产品相关 API
export const sysApi = {
  // 获取产品类目
  getCategories() {
    return request({
      url: '/api/products/categories',
      method: 'get'
    })
  },
  // 获取简介
  getShortDesc(start, end) {
    return request({
      url: `/api/products/shortDesc?start=${start}&end=${end}`,
      method: 'get'
    })
  },
  // 获取图片名称
  // http://localhost:9002/products/picName?category=Keychain&subCategory=Enamel%20Keychain
  getPicName(category, subCategory) {
    return request({
      url: `/api/products/picName?category=${category}&subCategory=${subCategory}`,
      method: 'get'
    })
  },

  sendEmail(mailData) {
    return request({
      url: '/api/products/email',
      data: mailData,
      method: 'post'
    })
  },

  sendEmailPro(mailData) {
    return request({
      url: '/api/products/emailpro',
      data: mailData,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js